// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { GatewayProviderCategorySchema } from '../inputTypeSchemas/GatewayProviderCategorySchema'
import { GatewaySourceTypeSchema } from '../inputTypeSchemas/GatewaySourceTypeSchema'

/////////////////////////////////////////
// GATEWAY SCHEMA
/////////////////////////////////////////

export const GatewaySchema = z.object({
  providerCategory: GatewayProviderCategorySchema,
  sourceType: GatewaySourceTypeSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  surfaceId: z.string(),
  hostname: z.string(),
  provider: z.string().nullable(),
  ips: z.string().array(),
  resolvedDomainIds: z.string().array(),
  cloudProvider: z.string().nullable(),
  cloudAccountRef: z.string().nullable(),
  cloudResourceId: z.string().nullable(),
  originHosts: z.string().array(),
  lastSeenAt: z.coerce.date().nullable(),
  deprovisionedAt: z.coerce.date().nullable(),
  vhostEnumCompletedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type Gateway = z.infer<typeof GatewaySchema>

export default GatewaySchema;
